import { ApiConfig, getEnvironment360BizURL, getFetchApiOptions } from '../configs/appConfig';
import { getHeaders } from './dataService';
import fetchClient from './fetchClient';

export const deleteTemporaryImportArchiveDocument = async (documentRecnos: string): Promise<void> => {
    const headers = await getHeaders();
    await fetchClient(getEnvironment360BizURL() + ApiConfig.DeleteTemporaryImportArchiveDocuments, {
        body: JSON.stringify({ documentRecnos }),
        headers,
        method: 'POST',
        ...getFetchApiOptions()
    });
};